// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file nodebase/v1/device.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import { DeviceService } from "./device_pb";

/**
 * @generated from rpc nodebase.v1.DeviceService.RegisterDevice
 */
export const registerDevice = DeviceService.method.registerDevice;

/**
 * @generated from rpc nodebase.v1.DeviceService.ListDevices
 */
export const listDevices = DeviceService.method.listDevices;

/**
 * RenameDevice gives a device the name its owner calls it, replacing the
 * hostname registration reported. The name becomes the user's from that
 * moment: re-registration stops overwriting it, so a reinstall cannot
 * silently revert "书房台式机" to "DESKTOP-9F3K2A1".
 *
 * @generated from rpc nodebase.v1.DeviceService.RenameDevice
 */
export const renameDevice = DeviceService.method.renameDevice;

/**
 * @generated from rpc nodebase.v1.DeviceService.RevokeDevice
 */
export const revokeDevice = DeviceService.method.revokeDevice;

/**
 * SubmitDiagnosticReport is always user-triggered. The client applies its
 * strict share scrub before sending; the server repeats that scrub before
 * storage and expires the report after a short retention window.
 *
 * @generated from rpc nodebase.v1.DeviceService.SubmitDiagnosticReport
 */
export const submitDiagnosticReport = DeviceService.method.submitDiagnosticReport;

/**
 * SubmitFeedback stores only text the signed-in person explicitly enters.
 * It never attaches diagnostics, files, environment variables, or command
 * history; those remain behind the separate diagnostic disclosure.
 *
 * @generated from rpc nodebase.v1.DeviceService.SubmitFeedback
 */
export const submitFeedback = DeviceService.method.submitFeedback;

/**
 * GetEnhancedDiagnosticPlan returns a short-lived, server-bounded carrier
 * echo plan. It is user-triggered by the hidden Desktop diagnostic page and
 * never carries the device's WireGuard identity or a Worker route.
 *
 * @generated from rpc nodebase.v1.DeviceService.GetEnhancedDiagnosticPlan
 */
export const getEnhancedDiagnosticPlan = DeviceService.method.getEnhancedDiagnosticPlan;
